import { render, staticRenderFns } from "./TaskNotice.vue?vue&type=template&id=539f48e2&scoped=true&"
import script from "./TaskNotice.vue?vue&type=script&lang=js&"
export * from "./TaskNotice.vue?vue&type=script&lang=js&"
import style0 from "./TaskNotice.vue?vue&type=style&index=0&id=539f48e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539f48e2",
  null
  
)

export default component.exports